import { Link } from '@mui/material';
import { FunctionComponent } from 'react';
import { Environment } from '../util/Environment';

export const EmailSupportLink: FunctionComponent = () =>
	<Link href={`mailto:${Environment.supportEmail}`}>{Environment.supportEmail}</Link>;